// extracted by mini-css-extract-plugin
export default {"selection-card":"LeaseFeeOptions_selection-card__nGYb5"};